import React, { useEffect, useState, useRef  } from "react";
import Popup from "../Modals/Popup";
import { useNavigate,useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";


interface LinkItems {
    location: string;
}


interface asideList {
    jobId: string;
    jobTitle: string;
    location: string;
    jobCategory: string;
}

interface asideLinkList{
    jobTitle: string;
    url:string;
}

interface AsideBoxProps {
    title: string;
    description: string;
    subTitle: string;
    fullLine: boolean;
    asideBoxButtonClass: string;
    asideBoxButtonText: string;
    asideBoxButton: boolean;
    asideBoxInputClass: string;
    asideBoxInputPlaceHolder: string;
    asideBoxEmail: boolean;
    customBodyClass: string;
    asideList: boolean;
    asideListDetails: asideList[];
    asideListDetailsLink: asideLinkList[];
    asideSocialIcons: boolean;
    asideSocialTitle: string;
    asideBoxItemShowLength: number;
    asideBoxFolderIcon: boolean;
    asideBoxLocationIcon: boolean;


}

const AsideBox = ({

    title,
    description,
    subTitle,
    fullLine,
    asideBoxButtonClass,
    asideBoxButtonText,
    asideBoxButton,
    asideBoxInputClass,
    asideBoxInputPlaceHolder,
    asideBoxEmail,
    customBodyClass,
    asideList,
    asideListDetails,
    asideListDetailsLink,
    asideSocialIcons,
    asideSocialTitle,
    asideBoxItemShowLength,
    asideBoxFolderIcon,
    asideBoxLocationIcon

}: AsideBoxProps) => {

    
    const navigation = useNavigate();
    const location = useLocation();
    const socialFaceBook = process.env.REACT_APP_FACEBOOK_URL?.replace("#TITLE#", asideSocialTitle).replace("#URL#", window.location.href);
    const socialLinkedIn = process.env.REACT_APP_LINKEDIN_URL?.replace("#URL#", `${encodeURIComponent(window.location.origin)}/share${encodeURIComponent(window.location.pathname)}`).replace("#TITLE#", asideSocialTitle);
    const socialTwitter = process.env.REACT_APP_TWITTER_URL?.replace("#TITLE#",asideSocialTitle).replace("#URL#",window.location.href);

    const [selectedIndex, setSelectedIndex] = useState<number | 0>(0);
    const [selectedJob, setSelectedJob] = useState('');
    const [selectedJobId, setSelectedJobId] = useState('');
    const getMoreLocations = () => {

        return (
            <div>

                <div className="margin-b-20">

                    <ul>
                        {/* {asideListDetails[selectedIndex].asideBoxLinks.map(item => (
                            <li className="pad-10">
                                {item.location}
                            </li>
                        ))} */}
                    </ul>
                </div>

            </div>
        );
    };
    const containerRef = useRef<HTMLDivElement>(null);
    const [showMore, setShowMore] = useState(false);
    
    const toggleShowMore = () => {
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
          }
        setShowMore(!showMore);
    };
    const moreLocations = getMoreLocations();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        return () => setShowModal(false);
        
    }, []);
 
   
    const handleClose = () => setShowModal(false);
    const handleShow = (index: number) => {
        setShowModal(true);
        setSelectedIndex(index);
        //setSelectedJob(asideListDetails[selectedIndex].title);

    };

    const smilarJobRedirect = (jobId: string,jobTitle:string) => {
        setShowMore(false);
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
        const smilarJobUrl = `/career-details/${encodeURIComponent(jobId)}/${encodeURIComponent(jobTitle)}${location.search}`;
        navigation(smilarJobUrl);
        window.scrollTo(0, 0);
    };

    const handleCategoryClick = (category: string) => {
        const matchedLink = asideListDetailsLink.find(link => link.jobTitle === category);
        const categoryJobUrl = `/career${location.search}#tab2?jobSearch=${category.trim().toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-").replace(/-+/g, "-")}`;
        navigation(categoryJobUrl);
        
    };
    
    return (
        <div className={`${customBodyClass}`} >
            <p className={`bellSlimBold txtBlack txtSize20 mar-neg-top-10 ${asideList ? 'pad-30' : ''}`}>{title}</p>
            {fullLine == true && (
                <hr className="asidebox-fullline"></hr>
            )
            }

            <p className="txtSize16">{description}</p>
            <p className="txtBold txtSize16">{subTitle}</p>
            {asideBoxButton == true && (

                <div className={`${asideBoxButtonClass}`}>

                    <input type="text" className={`${asideBoxInputClass}`} placeholder={`${asideBoxInputPlaceHolder}`} />
                    <button className="btn btn-default">{asideBoxButtonText}</button>

                </div>

            )
            }

            {asideBoxEmail == true && (

                <div className={`${asideBoxButtonClass}`}>

                    <button className="btn">{asideBoxButtonText}</button>

                </div>

            )
            }

            {asideList == true && (
                <>
                    <div>
                        <div  ref={containerRef}  className={`asidebox-content pad-30 ${asideBoxItemShowLength > 0 ?  !showMore ? 'asidebox-content-fixed-height':'':''}`}>
                            {asideListDetails.map((list: any, index: number) => {
                                return (
                                  <div className="pad-40-bottom">
                                    <p
                                      onClick={() =>
                                        smilarJobRedirect(list.jobId,list.jobTitle)
                                      }
                                      className="bellSlimBold txtBlack txtBold txtSize16 underline-on-hover cursor-pointer"
                                    >
                                      {list.jobTitle}
                                    </p>
                                    <div className="col-md-4 col-sm-12">
                                      <div>
                                        <p>
                                        <img src="/content/img/pin-4-16.png"></img>
                                          <span className="vertical-align-middle">
                                            &nbsp;&nbsp;{list.location}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-8 col-sm-12 pad-left-20-md">
                                      <p>
                                        {asideBoxFolderIcon == true && (
                                           <img src="/content/img/briefcase-9-16.png"></img>
                                        )}
                                        
                                        <a
                                          className="vertical-align-middle cursor-pointer underline-on-hover margin-5-left"
                                          onClick={() => handleCategoryClick(list.jobCategory)}
                                        >
                                          {list.jobCategory}
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                );
                            })}
                        </div>
                        <hr className="asidebox-fullline"></hr>
                        <div className="asidebox-footer pad-30">
                            {asideListDetails.length > asideBoxItemShowLength && (
                                <div className="asidebox-link">                                    
                                    <a onClick={toggleShowMore} className="toggle-button">
                                        {showMore ? 'Show Less' : 'Show More'}
                                    </a>
                                </div>)

                            }
                        </div>
                    </div>
                </>
            )}

            {asideSocialIcons == true && (

                <div className="footer-media-box">
                    <ul className="asidebox-media-items">
                        <li className="footer-media-item"><a href={socialFaceBook} target="_blank"><img src="/content/img/facebook.png" alt="facebook"/></a></li>
                        <li className="footer-media-item"><a href={socialLinkedIn} target="_blank"><img src="/content/img/linkedin-footer.png" alt="linkedin"/></a></li>
                        <li className="footer-media-item"><a href={socialTwitter} target="_blank"><img src="/content/img/twitt-footer1.png" alt="twitter"/></a></li>                       
                    </ul>
                </div>


            )}

            {showModal == true && (
                <div>
                    <Popup
                        title={selectedJob}
                        bodyContent={moreLocations}
                        handleClose={handleClose}
                        closeButtonClassName={"btn btn-default txtCenter"}
                        closeButtonText={"ok"}
                    />
                </div>
            )}
        </div>

    );

};
export default AsideBox;